import { isRTLLanguage } from "@/i18n/utils";

import { useAppLanguage } from "./useAppLanguage";

export const useIsRTL = () => {
  const { language } = useAppLanguage();

  return isRTLLanguage(language);
};
